import { makeStyles, tokens } from "@fluentui/react-components";

export const useSuggestionSearchInputStyles = makeStyles({
  textarea: {
    minHeight: "112px",
    border: `${tokens.colorNeutralStroke1}`,
  },
});
